<template>
  <v-dialog v-model="showTextTemplateDialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ title }}</span>
      </v-card-title>
      <v-card-text>
        <TextTemplateForm
          :errors="violations"
          :values="item"
          :loading="isLoading"
          ref="textTemplateDialogForm"/>
      </v-card-text>
      <v-card-actions>
        <v-btn text @click="showTextTemplateDialog = false">{{ $t('Close') }}</v-btn>
        <v-spacer/>
        <v-btn class="mainAccent lighten-3" dark @click="resetForm">{{ $t('Reset') }}</v-btn>
        <v-btn color="primary" @click="sendForm">{{ $t('Submit') }}</v-btn>
      </v-card-actions>
    </v-card>
    <Loading :visible="isLoading"/>
  </v-dialog>
</template>

<script>
import {createHelpers} from 'vuex-map-fields';
import TextTemplateForm from './Form';
import NotificationMixin from '../../mixins/NotificationMixin';
import Loading from "@/components/Loading";
import {mapActions, mapGetters} from "vuex";

const servicePrefix = 'TextTemplate';

const {mapFields} = createHelpers({
  getterType: 'textTemplate/getField',
  mutationType: 'textTemplate/updateField'
});

export default {
  name: "TextTemplateDialog",
  servicePrefix,
  mixins: [NotificationMixin],
  components: {
    Loading,
    TextTemplateForm
  },
  props: {
    value: Boolean,
    title: {
      type: String,
      required: true
    },
    handleCreated: {
      type: Function,
      required: false
    },
    handleUpdated: {
      type: Function,
      required: false
    },
    textTemplateItem: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      item: {},
      updateMessage: this.$t("successfullyUpdated"),
      createMessage: this.$t("successfullyCreated"),
    }
  },
  computed: {
    ...mapFields(['error', 'isLoading', 'created', 'violations', 'updated', 'byId']),
    ...mapGetters('textTemplate', ['find']),
    showTextTemplateDialog: {
      get() {
        return this.value;
      },
      set(value) {
        if (!value) {
          this.$emit('close')
        }
      }
    },
  },
  methods: {
    ...mapActions('textTemplate', {
      create: 'create',
      update: 'update',
      resetData: 'resetData',
      retrieve: 'load'
    }),
    sendForm() {
      if (this.isValidForm()) {
        let model = this.$refs.textTemplateDialogForm.$v.item.$model;
        if (this.handleUpdated && model['@id']) {
          this.update(model);
        }
        if (this.handleCreated && !model["@id"]) {
          this.create(model);
        }
      }
    },
    reset() {
      this.$refs.textTemplateDialogForm.$v.$reset();
    },
    resetForm() {
      this.item = {...this.textTemplateItem};
      if (this.$refs['textTemplateDialogForm']) {
        this.$refs.textTemplateDialogForm.$v.$reset();
      } 
    },
    isValidForm() {
      this.$refs.textTemplateDialogForm.$v.$touch();
      return !this.$refs.textTemplateDialogForm.$v.$invalid;
    },
  },
  watch: {
    textTemplateItem() {
      this.item = {...this.textTemplateItem};
      this.resetForm();
    },
    created(created) {
      if (!created) {
        return;
      }
      this.showMessage(this.createMessage);
      if (this.handleCreated) {
        this.handleCreated(this.created);
        this.showTextTemplateDialog = false;
      }
    },
    updated() {
      this.showMessage(this.updateMessage);
      if (this.handleUpdated) {
        this.handleUpdated(this.updated);
        this.showTextTemplateDialog = false
      }
    },
    error(message) {
      message && this.showError(message);
    },
  },
  created() {
    this.item = {...this.textTemplateItem};
  }
}
</script>
